import {
  BooleanField,
  CreateButton,
  Datagrid,
  DateField,
  ExportButton,
  FilterButton,
  List,
  NumberField,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
} from 'react-admin';

const businessFilters = [
  <TextInput key="search" source="search" label="Search" alwaysOn />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'draft', name: 'Draft' },
      { id: 'pending_review', name: 'Pending Review' },
      { id: 'published', name: 'Published' },
      { id: 'suspended', name: 'Suspended' },
      { id: 'archived', name: 'Archived' },
    ]}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export function BusinessList() {
  return (
    <List
      filters={businessFilters}
      actions={<ListActions />}
      sort={{ field: 'created_at', order: 'DESC' }}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="slug" />
        <TextField source="status" />
        <TextField source="site_type" label="Site type" />
        <BooleanField source="is_verified" label="Verified" />
        <BooleanField source="has_owner" label="Has owner" />
        <NumberField source="rating_avg" label="Rating" options={{ maximumFractionDigits: 1 }} />
        <NumberField source="city_id" label="City ID" />
        <NumberField source="category_id" label="Category ID" />
        <DateField source="created_at" showTime />
      </Datagrid>
    </List>
  );
}
